import {combineReducers} from 'redux';
import toastReducer from './toastReducer';
import policyToastReducer from './policyToastReducer';
import layersReducer from "./layersReducer";
import modalVisibilityReducer from "./modalVisibilityReducer";
import combatReducer from "./combatReducer";
import authReducer from "./authReducer";
import lobbyReducer from "./lobbyReducer";
import selectedEntitiesReducer from "./selectedEntitiesReducer";
import serverTimeReducer from "./serverTimeReducer";
import reactionsReducer from "./reactionsReducer";
import tutorialReducer from "./tutorialReducer";
import missionReducer from "./missionReducer";
import constructionPlanReducer from "./constructionPlanReducer";
import goblinsTrapKillNoticeReducer from "./goblinsTrapKillNoticeReducer";
import roundStandingsReducer from "./roundStandingsReducer";
import matchChatReducer from "./matchChatReducer";
import turnInputLockReducer from "./turnInputLockReducer";
import unitAutoSelectionReducer from "./unitAutoSelectionReducer";

const internalReducer = combineReducers({
  toast: toastReducer,
  policyToast: policyToastReducer,
  layers: layersReducer,
  modalVisibility: modalVisibilityReducer,
  combat: combatReducer,
  auth: authReducer,
  lobby: lobbyReducer,
  selectedEntities: selectedEntitiesReducer,
  serverTime: serverTimeReducer,
  reactions: reactionsReducer,
  tutorial: tutorialReducer,
  mission: missionReducer,
  constructionPlan: constructionPlanReducer,
  goblinsTrapKillNotice: goblinsTrapKillNoticeReducer,
  roundStandings: roundStandingsReducer,
  // Модерируемый чат ИИ-матча: свои сообщения на проверке и пауза чата
  matchChat: matchChatReducer,
  // Блокировка ввода после нуля таймера хода (utils/gameState/turn/turnInputLock)
  turnInputLock: turnInputLockReducer,
  // Пропуски хода отрядами и тумблер автовыбора (change unit-auto-selection)
  unitAutoSelection: unitAutoSelectionReducer,
});

// Wrapper to handle special actions that need access to multiple state slices
const privateStateReducer = (state, action) => {
  switch (action.type) {
    case 'RESET_STATE': {
      const newState = internalReducer(undefined, action);
      return {
        ...newState,
        auth: state?.auth,
      };
    }
    default:
      return internalReducer(state, action);
  }
};

export default privateStateReducer;

